import { authenticatedFetch } from '../../../../api/request';

export default async function getAppointmentHistory(setErrorMessage) {
    const onError = () => setErrorMessage('No se puede obtener el historial de citas.');
    return await authenticatedFetch('/appointment-doctor/history', onError);
}
